var map = {
	"./Clinic.png": 138,
	"./Restaurant.png": 139,
	"./Salon.png": 140,
	"./Service Center.png": 141,
	"./Shop.png": 142,
	"./Workshop.png": 143,
	"./primary.png": 66
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68;